import { useState } from "react"
import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import { MultiSelect } from "src/@/components/ui/multi-select"
import { RowInput } from "src/components/forms/RowInput"
import SendMessage from "./SendMessage"
import { Switch } from "src/@/components/ui/switch"
import Scrollbar from "src/components/Scrollbar"
import { ButtonLoading } from "src/@/components/use/ButtonLoading"

export default function ModalDirecionamentos({
  open,
  onClose,
  onSubmit,
  action,
  recebe,
  changeRecebe,
  changeDepartament,
  changeUser,
  usersSelect,
  users,
  departamentSelect,
  departaments,
  loadingCreate,
  data,
  changeBlock,
  sendMessage,
  changeSendMessage
}) {

  let departmentsFormatted = departaments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>

      <DialogContent className="sm:max-w-[605px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Novo direcionamento" : "Editar Direcionamento"}
          </DialogTitle>

        </DialogHeader>
        <Scrollbar className="h-[500px]">
        <div className="grid gap-4 py-4">
          <div className="w-1/2">
            <RowInput
              info="Valor enviado pelo cliente e direcionado para os setores e usuários selecionados."
              label="Recebe"
              input={<Input
                onChange={changeRecebe}
                value={recebe}
              />}
            />
          </div>


          <div>
            <label className="block text-sm font-medium">Usuarios</label>

            <MultiSelect
              options={usersFormatted}
              onValueChange={(e) => {
                changeUser(e);
              }}
              defaultValue={usersSelect}
              placeholder="Selecionar usuarios"
              variant="inverted"
              animation={2}
              maxCount={3}
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Setores</label>
            <MultiSelect
              options={departmentsFormatted}
              onValueChange={(e) => {
                changeDepartament(e);
              }}
              defaultValue={departamentSelect}
              placeholder="Selecionar setores"
              variant="inverted"
              animation={2}
              maxCount={3}
            />
          </div>

          {/* <div className="flex items-center gap-2 mt-4 mb-2">
               <Switch
                  checked={sendMessage}
                  onCheckedChange={value => {
                    changeSendMessage(value)
                    console.log('isSendMessages', value)
                  } }
              />
                   <label
              htmlFor="terms"
              className="text-xs capitalize font-medium"
            >
              Enviar mensagem
            </label>
            </div> */}

          {/* {sendMessage && (
            <div>
              <SendMessage
                data={data}
                changeBlock={changeBlock}
              />
            </div>
          )} */}

        </div>
        </Scrollbar>
        <DialogFooter>
          <ButtonLoading loading={loadingCreate} className="bg-slate-700 h-8" onClick={onSubmit}>{action === "Criar" ? "Criar" : "Salvar"}</ButtonLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
